<template>
    <v-app>
        <v-main>
            <v-container fill-height>
                <v-row>
                    <v-col>
                        <v-card flat>
                            <div v-if="!loading">
                                <v-card-title>{{$t("select_warehouse")}}</v-card-title>
                                <v-card-text>
                                    <v-radio-group v-model="warehouseId">
                                        <v-radio
                                            v-for="(v, i) in warehouses" :key="i"
                                            :label="v.name"
                                            :value="v.id"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn class="primary" @click="handleClick" :disabled="!warehouseId">
                                        {{$t("submit")}}
                                    </v-btn>
                                </v-card-actions>
                            </div>
                            <div v-else>
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <v-skeleton-loader type="heading"/>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <v-skeleton-loader type="text" class="mb-3"/>
                                        <v-skeleton-loader type="text" class="mb-3"/>
                                        <v-skeleton-loader type="text" class="mb-3"/>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <v-skeleton-loader type="button"/>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-card>
                        <v-list>
                        </v-list>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import { search } from "../../services/stockJournal/warehouse";
export default {
    data() {
        return {
            warehouses: [],
            warehouseId: null,
            loading: false
        }
    },
    methods: {
        handleClick() {
            if(!this.warehouseId) return;
            this.$router.push({path:`/warehouse/${this.warehouseId}/stock-on-hand-warehouse`})
        },
        async fetchWarehouses() {
            this.loading = true;
            search("", 100).then(res => {
                this.warehouses = res.data;
            }).finally(() => {
                this.loading = false;
            })
        }
    },
    created() {
        this.fetchWarehouses();
    }
}
</script>

<style>

</style>